// ─── REST mock ───────────────────────────────────────────────────────────────

export const mockAccount = {
  id: 'mock-account-id-001',
  status: 'ACTIVE',
  clientApiSettings: {
    paSetting: {
      paState: 'ALLOWED',
    },
  },
  clientInternalInfo: {
    scaleModel: {
      managementAccountId: null,
    },
  },
  kycRecord: {
    status: 'NO_STATUS',
  },
};

// ─── GraphQL mocks (keyed by operationName) ──────────────────────────────────

export const mockGraphQL: Record<string, any> = {
  getAccountKYBStatus: {
    getAccountKYBStatus: {
      caseId: null,
      status: 'NO_STATUS',
    },
  },

  getI18nContent: {
    getI18nContent: {
      i18nContentLabel: [
        { key: 'KYB_TASKFLOW_TITLE', label: 'Payment Activation' },
        { key: 'KYB_NAV_APPLICATION', label: 'Application' },
        { key: 'KYB_NAV_ACTIVATION', label: 'Activation' },
        { key: 'KYB_NAV_CHOOSE_PAYMENT', label: 'Choose Payment' },
        { key: 'KYB_NAV_BUS_INFO', label: 'Business Info' },
        { key: 'KYB_NAV_REVIEW', label: 'Review' },
        { key: 'KYB_NAV_SELECT_RESERVE', label: 'Select Reserve' },
        { key: 'KYB_NAV_ACTIVATE_PAYMENT', label: 'Activate Payment' },
        { key: 'KYB_BUTTON_NEXT', label: 'Next' },
        { key: 'KYB_BUTTON_BACK', label: 'Back' },
        { key: 'KYB_BUTTON_SUBMIT', label: 'Submit' },
        { key: 'KYB_BUTTON_CONFIRM', label: 'Confirm' },
        { key: 'KYB_BUTTON_DONE', label: 'Done' },
        { key: 'KYB_BUTTON_DO_IT_LATER', label: 'Do it later' },
        { key: 'KYB_ERR_REQUIRED', label: 'This field is required' },
        { key: 'KYB_ERR_INVALID_TYPE', label: 'Invalid value' },
        { key: 'KYB_ERR_EXCEED_MIN', label: 'Value too small' },
        { key: 'KYB_ERR_EXCEED_MAX', label: 'Value too large' },
        { key: 'KYB_ERR_SHOULD_BE_INTEGER', label: 'Must be an integer' },
        { key: 'KYB_ERR_SHOULD_BE_POSITIVE', label: 'Must be positive' },
        { key: 'KYB_UPLOAD_VIEW', label: 'View' },
        { key: 'KYB_UPLOAD_REMOVE', label: 'Remove' },
        { key: 'KYB_UPLOAD_PREVIEW', label: 'Preview' },
        { key: 'KYB_IN_REVIEW_TITLE', label: 'Application In Review' },
        { key: 'KYB_IN_REVIEW_SUBTITLE', label: 'We are reviewing your application.' },
        { key: 'KYB_IN_REVIEW_EXTRA_TITLE', label: 'Supporting Documents' },
        { key: 'KYB_IN_REVIEW_EXTRA_SUBTITLE', label: 'Please upload supporting documents.' },
        { key: 'KYB_IN_REVIEW_UPLOAD_HINT', label: 'Max 10 files, 10MB each.' },
        { key: 'KYB_IN_REVIEW_UPLOAD_ERR_TOO_LARGE', label: 'File too large' },
        { key: 'KYB_IN_REVIEW_UPLOAD_ERR_FAILED', label: 'Upload failed' },
        { key: 'KYB_ACT_TITLE', label: 'Payment Methods Activating' },
        { key: 'KYB_ALL_ACT_TITLE', label: 'All Payment Methods Activated' },
        { key: 'KYB_ACT_ACTED_TITLE', label: 'Activated' },
        { key: 'KYB_ACT_ACTED_SUB', label: 'Ready to use' },
        { key: 'KYB_ACT_PENDING_TITLE', label: 'Pending' },
        { key: 'KYB_ACT_PENDING_SUB', label: 'Being reviewed' },
        { key: 'KYB_ACT_REJECT_TITLE', label: 'Rejected' },
        { key: 'KYB_ACT_REJECT_SUB', label: 'Not approved' },
        { key: 'KYB_ACT_NO_RESERVE_TITLE', label: 'No Reserve Required' },
        { key: 'KYB_ACT_NO_RESERVE_DESC', label: 'You do not need to set a reserve.' },
        { key: 'KYB_ACT_ALERT_AUTO_ACCEPTED', label: 'Reserve auto-accepted' },
        { key: 'KYB_APPROVE_RETRY_ALERT', label: 'Please review the updated reserve plan.' },
        { key: 'KYB_APPROVED_PHRASE', label: 'Approved! ' },
        { key: 'KYB_ACTIVATE_NEW_PAYMENT_METHODS', label: 'Activate New Payment Methods' },
      ],
      i18nContentImage: [],
    },
  },

  getDraft: {
    getDraft: null,
  },

  saveDraft: {
    saveDraft: { status: 'ok' },
  },

  getPaymentMethods: {
    getPaymentMethods: [
      {
        activationTimeMax: 0,
        activationTimeMin: 0,
        code: 'VISA',
        description: 'Visa 是全球最大的卡支付网络之一，可在大部分国家/地区发卡，并被全球大多数商家所接受。',
        isPopular: true,
        locations: [],
        name: 'Visa',
        productTypes: ["ONLINE_PAYMENTS", "PAYMENT_LINK", "XERO_INVOICE"],
        requireReserve: true,
        requiresOnlineWebsiteUrl: false,
        type: 'CARDS',
      },
      {
        activationTimeMax: 0,
        activationTimeMin: 0,
        code: 'MASTERCARD',
        description: 'Mastercard 是全球最大的卡支付网络之一，可在任何国家/地区发卡，并被全球大多数商家所接受。',
        isPopular: true,
        locations: [],
        name: 'Mastercard',
        productTypes: ["ONLINE_PAYMENTS", "PAYMENT_LINK", "XERO_INVOICE"],
        requireReserve: true,
        requiresOnlineWebsiteUrl: false,
        type: 'CARDS',
      },
      {
        activationTimeMax: 1,
        activationTimeMin: 1,
        code: 'AMEX',
        description: 'American Express 是全球最大的卡支付网络之一，可在任何国家/地区发卡，并被全球大多数商家所接受。',
        isPopular: true,
        locations: [],
        name: 'American Express',
        productTypes: ["ONLINE_PAYMENTS", "PAYMENT_LINK", "XERO_INVOICE"],
        requireReserve: true,
        requiresOnlineWebsiteUrl: false,
        type: 'CARDS',
      },
      {
        activationTimeMax: 0,
        activationTimeMin: 0,
        code: 'UNIONPAY',
        description: '银联国际即中国银联，是在中国大陆提供银行卡服务的主要卡组织。银联在亚太市场亦有较高的参与度。',
        isPopular: true,
        locations: [],
        name: '银联国际',
        productTypes: ["ONLINE_PAYMENTS", "XERO_INVOICE"],
        requireReserve: true,
        requiresOnlineWebsiteUrl: true,
        type: 'CARDS',
      },
      {
        activationTimeMax: 0,
        activationTimeMin: 0,
        code: 'APPLEPAY',
        description: 'ApplePay 是一种数字钱包方案，可存储消费者的卡片信息并用于网页端、移动端和店内支付，使结账过程变得简单、安全和可靠。',
        isPopular: true,
        locations: [],
        name: 'Apple Pay',
        productTypes: ["ONLINE_PAYMENTS", "PAYMENT_LINK", "XERO_INVOICE"],
        requireReserve: true,
        requiresOnlineWebsiteUrl: false,
        type: 'WALLET',
      },
      {
        activationTimeMax: 0,
        activationTimeMin: 0,
        code: 'GOOGLEPAY',
        description: 'Google Pay 是一种数字钱包方案，使消费者能够在实体店、应用程序内或网页端的兼容设备上使用保存在其 Google 帐户中的任何信用卡或借记卡进行支付。',
        isPopular: true,
        locations: [],
        name: 'Google Pay',
        productTypes: ["ONLINE_PAYMENTS", "PAYMENT_LINK", "XERO_INVOICE"],
        requireReserve: true,
        requiresOnlineWebsiteUrl: false,
        type: 'WALLET',
      },
      {
        activationTimeMax: 0,
        activationTimeMin: 0,
        code: 'JCB',
        description: 'JCB 是全球主要的卡支付网络之一，也是日本市场领先的信用卡发卡和收单机构。其交易可被全球 3400 万商户接受。',
        isPopular: true,
        locations: [],
        name: 'JCB',
        productTypes: ["ONLINE_PAYMENTS", "PAYMENT_LINK", "XERO_INVOICE"],
        requireReserve: true,
        requiresOnlineWebsiteUrl: false,
        type: 'CARDS',
      },
      {
        activationTimeMax: 0,
        activationTimeMin: 0,
        code: 'DISCOVER',
        description: 'Visa 是全球最大的卡支付网络之一，可在大部分国家/地区发卡，并被全球大多数商家所接受。',
        isPopular: false,
        locations: [],
        name: 'Discover',
        productTypes: ["ONLINE_PAYMENTS", "PAYMENT_LINK", "XERO_INVOICE"],
        requireReserve: true,
        requiresOnlineWebsiteUrl: false,
        type: 'CARDS',
      },
      {
        activationTimeMax: 0,
        activationTimeMin: 0,
        code: 'DINERS',
        description: 'Visa 是全球最大的卡支付网络之一，可在大部分国家/地区发卡，并被全球大多数商家所接受。',
        isPopular: false,
        locations: [],
        name: 'Diners',
        productTypes: ["ONLINE_PAYMENTS", "PAYMENT_LINK", "XERO_INVOICE"],
        requireReserve: true,
        requiresOnlineWebsiteUrl: false,
        type: 'CARDS',
      },
      {
        activationTimeMax: 3,
        activationTimeMin: 3,
        code: 'SKRILL',
        description: 'Skrill 是一家提供各种在线支付和资金转账服务的数字钱包提供商。',
        isPopular: false,
        locations: [],
        name: 'Skrill',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 0,
        activationTimeMin: 0,
        code: 'AIRWALLEX_PAY',
        description: 'CrossPayPro Pay 是 CrossPayPro 推出的支付方式，通过此方式，您的客户能够安全地使用他们在 CrossPayPro 账户中的资金对订单进行支付。',
        isPopular: false,
        locations: [],
        name: 'CrossPayPro Pay',
        productTypes: ["ONLINE_PAYMENTS", "PAYMENT_LINK", "XERO_INVOICE"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: false,
        type: 'WALLET',
      },
      {
        activationTimeMax: 3,
        activationTimeMin: 3,
        code: 'EPS',
        description: 'eps 是奥地利银行提供的一种安全的在线支付方式。 它使消费者能够轻松快捷地使用受信任的网上银行服务支付购买费用。',
        isPopular: false,
        locations: ["AT"],
        name: 'eps',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'ONLINE_BANKING_REDIRECT',
      },
      {
        activationTimeMax: 3,
        activationTimeMin: 3,
        code: 'BANCONTACT',
        description: '持有支付卡 Bancontact 的消费者可以直接通过比利时所有主要银行的在线支付系统进行支付。',
        isPopular: false,
        locations: ["BE"],
        name: 'Bancontact',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'ONLINE_BANKING_REDIRECT',
      },
      {
        activationTimeMax: 3,
        activationTimeMin: 1,
        code: 'WECHAT',
        description: '微信是一款广受欢迎的消息、社交媒体和移动支付应用程序，拥有 10 亿用户。 已将中国银行账户与微信支付关联的微信用户可以开始在其移动应用上使用微信支付进行在线购物。',
        isPopular: false,
        locations: ["CN"],
        name: '微信支付',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 3,
        activationTimeMin: 3,
        code: 'ALIPAYCN',
        description: '支付宝是一款广受欢迎的多功能移动支付应用程序。 截至 2020 年 6 月，它拥有超过 13 亿年活跃用户，在中国大陆处理了价值 17 万亿美元的年交易。',
        isPopular: false,
        locations: ["CN"],
        name: '支付宝',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 3,
        activationTimeMin: 3,
        code: 'GIROPAY',
        description: '使用 giropay，消费者可以通过网银安全支付：消费者的银行账户信息和交易细节受到充分的保护。 消费者在结账时无需额外注册即可直接使用 giropay。',
        isPopular: false,
        locations: ["DE"],
        name: 'giropay',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'ONLINE_BANKING_REDIRECT',
      },
      {
        activationTimeMax: 0,
        activationTimeMin: 0,
        code: 'BACS_DIRECT_DEBIT',
        description: 'Bacs（银行自动清算服务）直接借记是英国广泛使用的支付方式。该服务由 pay.uk 拥有并运营，有着非常严格的规则来保护购物者。当付款结果不需要当天确认的情况下，直接借记是一种简单、经济高效的定期付款方式。如果成功授权，大约需要 3 个工作日来确认付款成功或失败。如果需要额外设置新的授权，则需要 额外3 个工作日。',
        isPopular: false,
        locations: ["GB"],
        name: 'Bacs Direct Debit',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: true,
        requiresOnlineWebsiteUrl: false,
        type: 'BANK_DIRECT_DEBIT',
      },
      {
        activationTimeMax: 10,
        activationTimeMin: 3,
        code: 'ALIPAYHK',
        description: '由李嘉诚和蚂蚁金服共同控股的 AlipayHK 是支付宝的香港本地版本。 用户可以进行在线支付以及在商店和餐厅进行扫码支付。',
        isPopular: false,
        locations: ["HK"],
        name: 'Alipay HK',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 0,
        activationTimeMin: 0,
        code: 'FPS',
        description: 'FPS/转数快允许付款人通过香港的网上和手机银行向个人和企业进行即时境内转账。 转数快在香港是被广泛认的一种支付方式。 使用转数快结账时，付款人可扫描二维码，并在其手机银行 app 上验证交易以确认付款金额。商户可以享受轻松对账、成本节约、更快的结算时间和无拒付的便利。',
        isPopular: false,
        locations: ["HK"],
        name: '转数快',
        productTypes: ["ONLINE_PAYMENTS", "PAYMENT_LINK", "XERO_INVOICE"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: false,
        type: 'BANK_TRANSFER',
      },
      {
        activationTimeMax: 1,
        activationTimeMin: 1,
        code: 'DANA',
        description: 'DANA 是一家位于印度尼西亚的数字支付服务平台，提供支付、忠诚度积分和金融服务。 DANA 用户可以通过 DANA 余额、银行转账、信用卡以及向小型市场的现金存款等服务进行广泛的电子交易。',
        isPopular: false,
        locations: ["ID"],
        name: 'DANA',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 11,
        activationTimeMin: 11,
        code: 'DOKU_EWALLET',
        description: 'DOKU 钱包是印度尼西亚一种安全且广泛使用的支付方式，允许客户使用他们的钱包账户购买商品，同时让商家可以访问该国超过 2000 万在线客户。',
        isPopular: false,
        locations: ["ID"],
        name: 'DOKU Wallet',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 5,
        activationTimeMin: 5,
        code: 'MYBANK',
        description: 'MyBank 是意大利的一种安全数字支付解决方案，它在消费者的网银户和商家的银行账户之间建立了直接联系。',
        isPopular: false,
        locations: ["IT"],
        name: 'MyBank',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'ONLINE_BANKING_REDIRECT',
      },
      {
        activationTimeMax: 33,
        activationTimeMin: 33,
        code: 'PAYEASY',
        description: 'Pay-easy 是由日本多家支付网络管理组织提供的支付网络。 Pay-easy 是日本最受欢迎的支付方式之一，它允许购物者通过网上银行或各家银行的自动柜员机进行支付。',
        isPopular: false,
        locations: ["JP"],
        name: 'Pay-easy',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'ONLINE_BANKING_REDIRECT',
      },
      {
        activationTimeMax: 90,
        activationTimeMin: 30,
        code: 'KONBINI',
        description: 'Konbini 支付，也称为便利店支付，是日本第二大支付方式，它允许消费者在便利店进行线下现金支付以完成在线购物结账流程。 Konbini 支付可以通过各种连锁便利店进行，例如 7-11、Lawson、FamilyMart 和 Seicomart。',
        isPopular: false,
        locations: ["JP"],
        name: 'Konbini',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'CASH',
      },
      {
        activationTimeMax: 14,
        activationTimeMin: 7,
        code: 'KOREAN_LOCAL_CARD',
        description: '本地发行的银行卡是一种在韩国广为人知且值得信赖的支付方式。该付款方式将提供韩国网络支付 (KCP) 托管的银行卡付款页面，购物者可以在其中选择发卡银行并完成付款。',
        isPopular: false,
        locations: ["KR"],
        name: 'Korean Local Cards',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'CARDS',
      },
      {
        activationTimeMax: 14,
        activationTimeMin: 7,
        code: 'NAVER_PAY',
        description: 'Naver Pay是韩国领先互联网公司Naver Corporation提供的手机钱包。购物者注册卡或银行帐户详细信息到钱包，然后使用钱包在线支付时，无需输入或透露敏感的帐户信息。',
        isPopular: false,
        locations: ["KR"],
        name: 'NaverPay',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 14,
        activationTimeMin: 7,
        code: 'PAYCO',
        description: 'Payco是韩国的一款移动钱包。该钱包允许客户使用与Payco 账户关联的信用卡和借记卡进行付款。',
        isPopular: false,
        locations: ["KR"],
        name: 'Payco',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 14,
        activationTimeMin: 7,
        code: 'SAMSUNG_PAY',
        description: 'Samsung Pay 是三星为 Android 操作系统提供的手机钱包。该钱包预装在新的三星设备中。购物者可以在Samsung Pay上添加卡，然后使用该钱包进行付款。',
        isPopular: false,
        locations: ["KR"],
        name: 'SamsungPay',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 14,
        activationTimeMin: 7,
        code: 'ONLINE_BANKING',
        description: '网银转账允许韩国购物者从其银行账户进行实时转账，以在互联网上支付商品和服务费用。',
        isPopular: false,
        locations: ["KR"],
        name: 'Korean Online Banking ',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'ONLINE_BANKING_REDIRECT',
      },
      {
        activationTimeMax: 15,
        activationTimeMin: 15,
        code: 'KAKAOPAY',
        description: 'Kakao Pay 是位于韩国的 Kakao 提供的移动支付和数字钱包服务，允许用户进行移动支付和在线交易。 该服务支持账户登录支付和二维码。',
        isPopular: false,
        locations: ["KR"],
        name: 'Kakao Pay',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 14,
        activationTimeMin: 11,
        code: 'SEVEN_ELEVEN',
        description: '7-11 作为一家连锁便利店，在马来西亚是一种流行的现金支付方式，允许购物者用现金在线下购买商品和服务。 购物者可以在当地的任何一家 7-11 商店进行付款。',
        isPopular: false,
        locations: ["MY"],
        name: '7-Eleven',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'CASH',
      },
      {
        activationTimeMax: 28,
        activationTimeMin: 28,
        code: 'GRABPAY',
        description: 'GrabPay 为消费者提供了在一个应用程序中支付日常服务费用和下单商品的便利方案。',
        isPopular: false,
        locations: ["MY"],
        name: 'GrabPay MY',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 28,
        activationTimeMin: 28,
        code: 'SHOPEE_PAY',
        description: 'ShopeePay 是 Shopee 的官方电子钱包，由 Bangko Sentral ng Pilipinas 监管，让购物者可以方便地为线上和线下购物充值和付款。',
        isPopular: false,
        locations: ["MY"],
        name: 'Shopee Pay',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 28,
        activationTimeMin: 28,
        code: 'BOOST',
        description: 'Boost 是马来西亚的生活方式电子钱包，为购物者提供安全的无现金移动端支付体验。',
        isPopular: false,
        locations: ["MY"],
        name: 'Boost',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 5,
        activationTimeMin: 5,
        code: 'TNG',
        description: 'Touch \'n Go eWallet 是马来西亚数字钱包和在线支付平台，由 Touch \'n Go 和蚂蚁金服在吉隆坡成立。',
        isPopular: false,
        locations: ["MY"],
        name: 'Touch \'n Go',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 14,
        activationTimeMin: 7,
        code: 'DUIT_NOW',
        description: 'Duitnow 是马来西亚流行的即时银行转账网络。它支持购物者使用网络中银行和非银机构的应用程序进行支付。',
        isPopular: false,
        locations: ["MY"],
        name: 'Duitnow',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'BANK_TRANSFER',
      },
      {
        activationTimeMax: 3,
        activationTimeMin: 3,
        code: 'IDEAL',
        description: 'iDEAL 于 2005 年推出，为商家提供支付保证，同时让消费者能够通过他们的手机银行应用程序或网上银行账户进行在线支付。 iDEAL 基于 SEPA 信用转账，与银行提供的网上银行系统无缝集成。',
        isPopular: false,
        locations: ["NL"],
        name: 'iDEAL',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'ONLINE_BANKING_REDIRECT',
      },
      {
        activationTimeMax: 13,
        activationTimeMin: 13,
        code: 'DRAGONPAY',
        description: 'Dragonpay 是一家位于菲律宾的在线支付解决方案提供商，专注于本地支付渠道。 通过其服务，购物者可以在线购买商品和服务，并在线下或通过网银扣款进行支付。',
        isPopular: false,
        locations: ["PH"],
        name: 'Dragonpay',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'BANK_TRANSFER',
      },
      {
        activationTimeMax: 1,
        activationTimeMin: 1,
        code: 'ONLINE_BANKING',
        description: '菲律宾网上银行允许菲律宾客户使用网银完成在线支付。',
        isPopular: false,
        locations: ["PH"],
        name: 'Philipines Online Banking',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'ONLINE_BANKING_REDIRECT',
      },
      {
        activationTimeMax: 1,
        activationTimeMin: 1,
        code: 'GCASH',
        description: 'GCash 是由 Mynt 运营的数字钱包应用程序，Mynt 是 Globe Telecom、Ayala Corporation 和 Ant Financial 的合作伙伴。 GCash提供包括汇款、二维码支付、账单支付等服务，并已集成到Shopee、Lazada和Zalora等主要电子商务网站。',
        isPopular: false,
        locations: ["PH"],
        name: 'GCash',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 6,
        activationTimeMin: 6,
        code: 'BLIK',
        description: 'BLIK 是波兰的一种支付方式，用户无需支付卡即可使用他们的移动银行应用程序进行支付。',
        isPopular: false,
        locations: ["PL"],
        name: 'BLIK',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'ONLINE_BANKING_REDIRECT',
      },
      {
        activationTimeMax: 8,
        activationTimeMin: 8,
        code: 'P24',
        description: 'Przelewy24 是一个位于波兰的实时网上银行转账支付方式，通常简称为 P24。 Przelewy24 与所有波兰银行合作运营。',
        isPopular: false,
        locations: ["PL"],
        name: 'Przelewy24 | P24',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'ONLINE_BANKING_REDIRECT',
      },
      {
        activationTimeMax: 8,
        activationTimeMin: 8,
        code: 'GRABPAY',
        description: 'GrabPay 是总部位于新加坡的跨国公司 Grab Holdings Inc. 提供的支付服务，作为第三方商家之间的数字支付服务，通过提供一系列无现金支付方式，让客户可以使用该应用程序完成购买。',
        isPopular: false,
        locations: ["SG"],
        name: 'GrabPay SG',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 14,
        activationTimeMin: 14,
        code: 'SAM_KIOSK',
        description: '新加坡消费者可以选择使用借记卡在自助售货机上支付他们的在线购物账单。',
        isPopular: false,
        locations: ["SG"],
        name: 'Singapore Kiosk Payments (SAM Kiosk)',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'BANK_TRANSFER',
      },
      {
        activationTimeMax: 14,
        activationTimeMin: 7,
        code: 'PAY_NOW',
        description: 'PayNow 是新加坡流行的即时银行转账网络。它支持购物者使用网络中银行和非银机构的应用程序进行支付。',
        isPopular: false,
        locations: ["SG"],
        name: 'Paynow',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'BANK_TRANSFER',
      },
      {
        activationTimeMax: 14,
        activationTimeMin: 14,
        code: 'TESCO_LOTUS',
        description: 'Tesco Lotus 是泰国的一家大型连锁超市，在全国拥有 2000 多家门店。 消费者可以在任何可以处理和确认付款的 Tesco Lotus 商店离线支付他们的在线订单。',
        isPopular: false,
        locations: ["TH"],
        name: 'Tesco Lotus',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'CASH',
      },
      {
        activationTimeMax: 14,
        activationTimeMin: 7,
        code: 'PROMPT_PAY',
        description: 'Promptpay 是泰国流行的即时银行转账网络。它支持购物者使用网络中银行和非银机构的应用程序进行支付。',
        isPopular: false,
        locations: ["TH"],
        name: 'Promptpay',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'BANK_TRANSFER',
      },
      {
        activationTimeMax: 22,
        activationTimeMin: 22,
        code: 'TRUEMONEY',
        description: 'TrueMoney 是一款电子钱包应用程序，覆盖东南亚地区的 6 个国家（泰国、柬埔寨、缅甸、印度尼西亚、菲律宾和越南）。',
        isPopular: false,
        locations: ["TH"],
        name: 'TrueMoney',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 5,
        activationTimeMin: 5,
        code: 'RABBIT_LINE_PAY',
        description: 'Rabbit LINE Pay 是泰国前 2 大电子钱包之一。 Rabbit LINE Pay 允许泰国用户在线下和在线支付商品、转账给其他 LINE 用户、支付水电费和高速公路通行费，以及购买电影票。',
        isPopular: false,
        locations: ["TH"],
        name: 'Rabbit LINE Pay',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'WALLET',
      },
      {
        activationTimeMax: 14,
        activationTimeMin: 14,
        code: 'ONLINE_BANKING',
        description: '泰国网上银行允许泰国客户使用包括曼谷银行在内的五大银行的网银系统完成网上支付。',
        isPopular: false,
        locations: ["TH"],
        name: 'Thailand Online Banking',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'ONLINE_BANKING_REDIRECT',
      },
      {
        activationTimeMax: 14,
        activationTimeMin: 14,
        code: 'SEVEN_ELEVEN',
        description: '便利店支付是台湾地区仅次于刷卡支付的第二大流行支付方式。 消费者可以使用 CVS PIN 码在任何受支持的线下商店用现金支付他们的在线订单。',
        isPopular: false,
        locations: ["TW"],
        name: 'Taiwan Convenience Stores (7-Eleven)',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'CASH',
      },
      {
        activationTimeMax: 3,
        activationTimeMin: 3,
        code: 'SOFORT',
        description: '自 2014 年以来 Sofort 一直是 Klarna 集团的一部分。关注支付安全性的消费者可以通过 Sofort 的安全支付页面输入他们自己的网上银行详细信息，并使用这些信息完成支付。',
        isPopular: false,
        locations: ["AT", "BE", "CH", "DE", "ES", "GB", "IT", "NL", "PL"],
        name: 'Sofort',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'ONLINE_BANKING_REDIRECT',
      },
      {
        activationTimeMax: 8,
        activationTimeMin: 8,
        code: 'TRUSTLY',
        description: 'Trustly 是一家银行转账支付服务提供商。 借助 Trustly，消费者可以使用高度安全的支付选项直接从他们的银行账户发起支付，而不会有信息被盗或欺诈的风险。',
        isPopular: false,
        locations: ["DE", "DK", "EE", "ES", "FI", "GB", "LT", "LV", "NL", "PL", "PT", "SE", "SK"],
        name: 'Trustly',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'ONLINE_BANKING_REDIRECT',
      },
      {
        activationTimeMax: 5,
        activationTimeMin: 5,
        code: 'PAYSAFECASH',
        description: 'Paysafecash 是一种在线支付方式，允许消费者离线在零售地点支付在线购买费用。 消费者使用 Paysafecash 服务在各种设备上生成的条形码进行支付，并在支持的支付点以现金支付。',
        isPopular: false,
        locations: ["AT", "BE", "CY", "ES", "FR", "GB", "GR", "HR", "IE", "IT", "NL", "PL", "PT", "RO", "SE", "SK", "SL"],
        name: 'Paysafecash',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'CASH',
      },
      {
        activationTimeMax: 7,
        activationTimeMin: 2,
        code: 'KLARNA',
        description: 'Klarna 是一种流行的“先买后付”付款方式，在 20 多个国家/地区可用。在批准付款之前，Klarna 会对购物者进行信用检查。如果成功，Klarna 将承担付款的全部信用风险，并预先向您结算。',
        isPopular: false,
        locations: ["AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR", "GB", "GR", "HR", "HU", "IE", "IS", "IT", "LI", "LT", "LU", "LV", "MT", "NL", "NO", "PL", "PT", "RO", "SE", "SI", "SK", "US"],
        name: 'Klarna',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'BNPL',
      },
      {
        activationTimeMax: 5,
        activationTimeMin: 5,
        code: 'PAYSAFECARD',
        description: 'Paysafecard 是一种简单且安全的预付支付方式，允许消费者在不使用银行账户或信用卡信息的情况下进行支付。 消费者可以使用购买的 Paysafecard 上的 PIN 支付订单，或使用他们的 Paysafecard 帐户批准付款。',
        isPopular: false,
        locations: ["AT", "AU", "BE", "BG", "CA", "CH", "CY", "CZ", "DE", "DK", "ES", "FI", "FR", "GB", "GE", "GI", "GR", "HR", "HU", "IE", "IT", "LI", "LT", "LU", "MT", "MX", "NL", "NO", "NZ", "PE", "PL", "PT", "RO", "SE", "SI", "SK", "UY"],
        name: 'Paysafecard',
        productTypes: ["ONLINE_PAYMENTS"],
        requireReserve: false,
        requiresOnlineWebsiteUrl: true,
        type: 'CASH',
      },

      {
        activationTimeMax: 3,
        activationTimeMin: 1,
        code: 'MASTERCARD',
        description: 'Mastercard credit and debit cards',
        isPopular: true,
        locations: ['AU', 'US', 'GB'],
        name: 'Mastercard',
        productTypes: ['ONLINE_PAYMENTS'],
        requireReserve: true,
        requiresOnlineWebsiteUrl: true,
        type: 'CARD',
      },
      {
        activationTimeMax: 2,
        activationTimeMin: 1,
        code: 'ALIPAY',
        description: 'Alipay wallet',
        isPopular: false,
        locations: ['CN'],
        name: 'Alipay',
        productTypes: ['ONLINE_PAYMENTS'],
        requireReserve: false,
        requiresOnlineWebsiteUrl: false,
        type: 'WALLET',
      },
    ],
  },

  getPlatformPaymentsType: {
    getPlatformPaymentsType: null,
  },

  getPlatformPaymentMethods: {
    getPlatformPaymentMethods: null,
  },

  getScaleSettingByPlatformAccountId: {
    getScaleSettingByPlatformAccountId: null,
  },

  getClientLegalEntity: {
    getClientLegalEntity: {
      id: 'mock-legal-entity-id',
      profile: {
        businessDetails: {
          address: {
            countryCode: 'AU',
            postcode: '2000',
            state: { english: 'New South Wales', local: 'NSW' },
            streetAddresses: [{ english: '123 Mock Street', local: '123 Mock Street' }],
            suburb: { english: 'Sydney', local: 'Sydney' },
          },
          descriptionOfGoodsOrServices: 'Software products',
          industryCategory: { categoryCode: '7372' },
          tradingName: 'Mock Business',
        },
      },
    },
  },

  getMidRate: {
    getMidRate: {
      buyCcy: 'AUD',
      rate: 0.65,
      rateType: 'MID',
      sellCcy: 'USD',
    },
  },

  getMerchantData: {
    getMerchantData: {
      profile: {
        accountId: 'mock-account-id-001',
        legalEntityId: 'mock-legal-entity-id',
        paymentMethods: [],
        paymentTypeDistribution: [],
      },
    },
  },

  getNewPaymentMethodRequiredInfo: {
    getNewPaymentMethodRequiredInfo: {
      fulfillmentDaysRequired: false,
      paymentTypeDistributionRequired: false,
      websiteRequired: true,
    },
  },

  getOngoingCase: {
    getOngoingCase: null,
  },

  getReserveOptions: {
    getReserveOptions: {
      currentReserveOffer: {
        currency: 'USD',
        customizedReserve: null,
        delayedDays: 7,
        disabledOptions: [],
        fixedAmount: null,
        mandatoryDelayedDays: 0,
        rollingDays: 180,
        rollingDays2: null,
        rollingRate: '0.05',
        rollingRate2: null,
      },
      currentReserveOfferSourceCaseId: 'mock-case-id',
      paymentMethodsNeedReserve: ['Visa', 'Mastercard'],
      previousChoice: null,
      previousReserveOffer: null,
      previousReserveOfferSourceCaseId: null,
    },
  },

  getReserveOptionsForOngoingKyb: {
    getReserveOptionsForOngoingKyb: null,
  },

  getUserPaymentMethodsStatus: {
    getUserPaymentMethodsStatus: {
      pmList: [
        {
          code: 'VISA',
          name: 'Visa',
          requireReserve: true,
          status: 'IN_PROGRESS',
        },
      ],
    },
  },

  getUserReservePlan: {
    getUserReservePlan: {
      autoAccepted: false,
      currency: 'USD',
      currentReserveOffer: null,
      currentReserveOfferSourceCaseId: null,
      delayedDays: 0,
      fixedAmount: 0,
      kybOnboarded: false,
      mandatoryDelayedDays: 0,
      previousChoice: null,
      previousReserveOffer: null,
      previousReserveOfferSourceCaseId: null,
      rollingDays: 0,
      rollingRate: 0,
    },
  },

  getUserSelectedPaymentMethods: {
    getUserSelectedPaymentMethods: [
      {
        code: 'VISA',
        name: 'Visa',
        requireReserve: true,
        status: 'IN_PROGRESS',
      },
    ],
  },

  submitKyb: {
    submitKyb: { status: 'ok' },
  },

  addPaymentMethods: {
    addPaymentMethods: {
      message: null,
      ongoingCaseId: 'mock-ongoing-case-id',
      ongoingCaseStatus: 'NO_STATUS',
      status: 'ok',
    },
  },

  addSupplementalFiles: {
    addSupplementalFiles: { status: 'ok' },
  },

  selectReserve: {
    selectReserve: { status: 'ok' },
  },

  getFileUploadToken: {
    getFileUploadToken: [
      {
        endpoint: 'https://mock-upload-endpoint.example.com',
        form_data: { key: 'mock-key', policy: 'mock-policy' },
        id: 'mock-file-id',
      },
    ],
  },

  getApprovedPaymentMethodsForOngoingKyb: {
    getApprovedPaymentMethodsForOngoingKyb: [],
  },

  getInProgressPaymentMethodsForIncrementalPaymentActivation: {
    getInProgressPaymentMethodsForIncrementalPaymentActivation: [],
  },

  getInProgressPaymentMethodsForInitialPaymentActivation: {
    getInProgressPaymentMethodsForInitialPaymentActivation: [],
  },

  getInProgressPaymentMethodsForSelectReserve: {
    getInProgressPaymentMethodsForSelectReserve: [],
  },

  getInReviewPaymentMethods: {
    getInReviewPaymentMethods: [],
  },
};
